import {Label} from '@blueprintjs/core';
import React, {useState} from 'react';
import {countryOptions, provinceOptions} from '../modules/options';
import FilterSelect from './FilterSelect';
import Input from './Input';
import SelectBox from './SelectBox';

export default function AccountDetailsForm({account, onChange}) {
  const [formData, setFormData] = useState(account);

  const handleChange = (label, value) => {
    // Make sure there's a value unless it's address2
    if (value || label === 'address2') {
      setFormData(data => ({...data, [label]: value}));
      onChange({[label]: value});
    }
  };

  return (
    <form style={{alignItems: 'stretch'}}>
      <Input
        label="Business Name:"
        type="text"
        name="businessName"
        placeholder="Business Name"
        value={formData.name || ''}
        onChange={e => handleChange('name', e.target.value)}
        leftIcon="office"
        large={true}
        fill={true}
        hasError={!account.name}
      />
      <Input
        label="Phone Number:"
        type="telephone"
        name="phone"
        placeholder="Phone Number and Extension"
        value={formData.phone || ''}
        onChange={e => {
          // Stripe has a limit of 20 chars
          if (e.target.value.length <= 20) {
            handleChange('phone', e.target.value);
          }
        }}
        leftIcon="phone"
        large={true}
        fill={true}
        hasError={!account.phone}
      />
      <Input
        label="Address 1:"
        type="text"
        name="address1"
        placeholder="Address 1"
        value={formData.address1 || ''}
        onChange={e => handleChange('address1', e.target.value)}
        leftIcon="map-marker"
        large={true}
        fill={true}
        hasError={!account.address1}
      />
      <Input
        label="Address 2:"
        type="text"
        name="address2"
        placeholder="Address 2 (optional)"
        value={formData.address2 || ''}
        onChange={e => handleChange('address2', e.target.value)}
        leftIcon="map-marker"
        large={true}
        fill={true}
      />
      <Input
        label="City:"
        type="text"
        name="city"
        placeholder="City"
        value={formData.city || ''}
        onChange={e => handleChange('city', e.target.value)}
        leftIcon="map-marker"
        large={true}
        fill={true}
        hasError={!account.city}
      />
      <Label style={{marginBottom: '5px'}}>Province:</Label>
      <FilterSelect
        id="stateProv"
        items={provinceOptions}
        onSelect={item => {
          handleChange('stateProv', item.id);
        }}
        activeItem={{id: formData.stateProv || ''}}
        popoverProps={{minimal: true}}
      >
        <SelectBox hasError={!account.stateProv}>
          {formData.stateProv ? formData.stateProv : 'Select a Province'}
        </SelectBox>
      </FilterSelect>
      <br />
      <Label style={{marginBottom: '5px'}}>Country:</Label>
      <FilterSelect
        id="country"
        items={countryOptions}
        onSelect={item => {
          handleChange('country', item.name);
        }}
        activeItem={{id: formData.country || 'CA'}}
        popoverProps={{minimal: true}}
      >
        <SelectBox>
          {formData.country ? formData.country : 'Select a Country'}
        </SelectBox>
      </FilterSelect>
      <br />
      <Input
        label="Postal Code:"
        type="text"
        name="zipPostal"
        placeholder="Postal Code"
        value={formData.zipPostal || ''}
        onChange={e => handleChange('zipPostal', e.target.value)}
        leftIcon="map-marker"
        large={true}
        fill={true}
        hasError={!account.zipPostal}
      />
    </form>
  );
}
